module.exports = __webpack_public_path__ + "img/banner_skylife_promo_04.4091a5a1.png";